<template>
  <v-dialog v-model="powerPlantContractsList" max-width="800px" lazy>
    <v-card class="d-flex" style="flex-direction: column">
      <v-card-title class="font-weight-bold pb-0">
        Contratos
        <v-spacer></v-spacer>
        <v-btn
          icon
          flat
          color="error"
          @click="() => setPowerPlantContractsList(false)"
        >
          <v-icon color="black">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-data-table class="pt-3" :headers="contractsHeaders" :items="contracts">
        <template v-slot:items="props">
          <td class="text-xs-center">
            {{ props.item.status | FormatPowerPlantStatus }}
          </td>
          <td class="text-xs-center">
            {{ props.item.type | formatContractType }}
          </td>
          <td class="text-xs-center">
            <v-btn
              v-if="props.item.url ? props.item.url : props.item.contract"
              color="grey darken-1"
              dark
              flat
              @click="
                () =>
                  openContract(
                    props.item.url ? props.item.url : props.item.contract,
                  )
              "
            >
              <v-icon flat>receipt_long</v-icon>
            </v-btn>
          </td>
          <td class="text-xs-center">
            <v-btn
              color="grey darken-1"
              dark
              flat
              @click="openDeleteDialog(powerPlantId, props.item.id)"
            >
              <v-icon flat color="error">mdi-trash-can</v-icon>
            </v-btn>
          </td>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="showDeleteModal" max-width="290px" dark>
      <v-card color="#7C3DFF">
        <v-card-title class="headline"
          >Deseja remover este contrato?</v-card-title
        >
        <v-card-actions>
          <v-spacer />
          <v-btn color="red" @click="showDeleteModal = false" dark> Não </v-btn>
          <v-btn color="green" dark @click="deleteContract()"> Sim </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar :color="color" top v-model="snackbar" dark>
      <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
      <div>{{ snackMessage }}</div>
      <v-icon size="16" @click="snackbar = false"> mdi-close-circle </v-icon>
    </v-snackbar>
  </v-dialog>
</template>
<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { deleteContract } from "@/services/powerplants.js";
import { getPermission } from "../../services/permissions";

export default {
  name: "PowerPlantContractsList",
  props: {
    powerPlantId: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    contractsHeaders: [
      { text: "Status", align: "center", value: "status" },
      { text: "Tipo do contrato", align: "center", value: "type" },
      { text: "Link do contrato", align: "center", value: "url" },
      { text: "Excluir contrato", align: "center", value: "delete" },
    ],
    showDeleteModal: false,
    snackbar: false,
    color: "",
    snackMessage: "",
    contractDelete: null,
  }),

  computed: {
    ...mapState("configuration", ["powerPlantContractsList", "contracts"]),
    ...mapState(["user"]),
  },

  mounted() {
    this.getContracts(this.powerPlantId);
  },

  methods: {
    ...mapActions("configuration", ["getContracts"]),
    ...mapMutations("configuration", ["setPowerPlantContractsList"]),

    snack(message, color) {
      this.color = color;
      this.snackMessage = message;
      this.snackbar = true;
    },

    openContract(contract) {
      window.open(contract, "_blank").focus();
    },

    openDeleteDialog(powerPlantId, contractId) {
      this.contractDelete = {
        powerPlantId,
        contractId,
      };
      this.showDeleteModal = true;
      console.log(this.user);
    },

    async deleteContract() {
      this.showDeleteModal = true;
      try {
        const permission = await getPermission("delete_contract", this.user.id);

        if (!permission.data.has_permission) {
          this.snack("Usuário sem permissão para realizar essa ação", "red");
          this.showDeleteModal = false;
          return false;
        }
      } catch (err) {
        this.showDeleteModal = false;
        this.snack("Falha ao consultar permissão do usuário", "red");
        console.error("Falha ao consultar permissão", err);
        return false;
      }
      try {
        await deleteContract(
          this.contractDelete.powerPlantId,
          this.contractDelete.contractId,
        );
        this.snack("Contrato excluído com sucesso", "success");
      } catch (error) {
        this.snack("Erro ao excluir contrato", "error");
        console.error(error);
      }
      this.showDeleteModal = false;
    },
  },
};
</script>
<style scoped>
.status {
  transform: translateY(22px) !important;
}

.edit {
  transform: translateY(-10px) !important;
}
</style>
